import Main from "./components/Main/Main";
import Menu from "./components/Menu/Menu";

function App() {
  return (
    <div className="h-screen">
      <Menu></Menu>
      <Main></Main>
    </div>
  );
}

export default App;
